var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunningGirlFinishLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541.16,
    height: 493.63,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 541.16 493.63",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Checker_White"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebebeb",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1410",
    x1: 456.76,
    x2: 486.75,
    y1: 65.601,
    y2: 65.601,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#Checker_White"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1590",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1596",
    x1: 246.76,
    x2: 276.75,
    y1: 113.44,
    y2: 113.44,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#Checker_White"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.539)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-21.92)",
    d: "m344.67 471.64c0 12.145-52.008 21.989-116.16 21.989s-116.16-9.844-116.16-21.989c0-12.144 52.009-21.99 116.16-21.99s116.16 9.845 116.16 21.99",
    opacity: 0.5,
    strokeWidth: 1.1058
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.86 475.85c-3.867 2.755-11.384-1.16-16.791-8.746-5.405-7.585-6.654-15.969-2.788-18.726 3.868-2.754 11.384 1.161 16.792 8.746 5.405 7.586 6.653 15.97 2.787 18.726",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.04 469.16s-8.897 6.655-14.662 0.159c0 0-5.975-5.128-9.337-15.053 0 0 1.315 21.647 19.873 22.382 0 0 7.265 0.076 4.126-7.488",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9dec5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m229 422.44s43.553 21.614-4.386 34.275l-6.158-3.04s40.463-11.115 6.229-25.336c0 0 0.951-4.759 2.631-5.329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.77 394.06s-25.495 41.403-33.734-7.491l3.589-5.854s7.381 41.306 24.661 8.513c0 0 4.654 1.378 5.068 3.106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.55 395.45c3.598 1.485 7.819-0.477 9.43-4.38 1.613-3.904 4e-3 -8.272-3.596-9.757-3.598-1.485-7.82 0.476-9.43 4.378-1.614 3.904-4e-3 8.274 3.596 9.759"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m230.19 387.61s6.233-3.257 11.151-2.767c0 0-9.272-21.06-25.87-26.237",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.29 415.55 8.559 1.621-15.264 20.873s-26.616-4.589-35.852-38.883c0 0 36.478 15.237 42.557 16.389",
    fill: "#006837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.07 441.61c-3.29-3.422-0.512-11.43 6.203-17.886 6.717-6.455 14.828-8.914 18.118-5.49s0.514 11.431-6.202 17.886-14.829 8.914-18.119 5.49",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.01 442.79s-7.881-7.831-2.296-14.48c0 0 4.201-6.66 13.529-11.432 0 0-21.223 4.456-19.242 22.922 0 0 0.984 7.198 8.009 2.99",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.18 422.08s-15.027 46.24-34.547 0.661l2.11-6.533s16.898 38.405 25.973 2.465c0 0 4.847 0.246 5.657 1.827",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.58 399.83s-14.959 5.959-21.966 15.124c0 0 21.142 5.875 29.637 16.54 0 0 5.145-12.728 18.073-15.35 0 0-7.383-8.283-25.744-16.314",
    fill: "#006837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.52 366.77-16.866-2.43 2.16-14.992 16.867 2.431z",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.69 350.17 16.555 4.592-0.034 0.231s-6.282 1.132-17.031-1.286z",
    fill: "#f7931e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.13 304.63c-4.575 31.745-32.481 53.99-62.331 49.689-29.849-4.304-50.339-33.525-45.764-65.269 4.576-31.746 32.485-53.992 62.334-49.69 29.85 4.304 50.337 33.525 45.761 65.27",
    fill: "#f7dec4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.47 306.79c-0.849 5.88-6.302 9.965-12.187 9.116-5.884-0.847-9.965-6.306-9.117-12.187 0.848-5.883 6.304-9.963 12.187-9.115 5.885 0.849 9.965 6.304 9.117 12.186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.09 302.57c-0.34 2.37-2.541 4.011-4.912 3.67-2.374-0.342-4.02-2.54-3.678-4.909 0.341-2.373 2.54-4.016 4.915-3.673 2.37 0.342 4.016 2.538 3.675 4.912",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.78 307.17c-0.44 3.047-3.341 5.153-6.48 4.701-3.138-0.454-5.328-3.294-4.888-6.34 0.44-3.049 3.34-5.153 6.48-4.699 3.14 0.453 5.327 3.289 4.888 6.338",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.84 291.34s-17.02-15.116-37.212-11.082c0 0 18.84-20.159 37.212 11.082",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.04 274.91c-2.7265 6e-3 -5.1633 0.92461-7.0078 1.9199-4.5874 0.98988-7.8379 4.0938-7.8379 4.0938 0.562-0.42 2.8945-0.15625 2.8945-0.15625 0.89076-0.66636 1.8245-1.2258 2.748-1.6973 0.76636-7e-3 1.5449 0.0762 1.5449 0.0762 0.98471-0.73642 2.0215-1.3433 3.0391-1.8438 1.5414-0.42692 2.584-0.5625 2.584-0.5625-0.33403-0.0637-0.66623-0.11252-0.99415-0.14649 2.8952-1.1626 5.2832-1.4746 5.2832-1.4746-0.76836-0.14634-1.5212-0.21059-2.2539-0.20898z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.76 326.2c-0.786 5.454-7.077 9.061-14.05 8.056-6.975-1.006-11.991-6.242-11.205-11.697s7.078-9.061 14.053-8.055c6.971 1.004 11.987 6.24 11.202 11.696",
    fill: "#f4c283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.53 281.05s22.766-2.503 37.32 10.331c0 0-17.973-10.068-37.32-10.331",
    fill: "#f69220",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.67 333.73s-11.89-1.855-26.609-8.799c0 0-0.375 15.848 6.399 24.903 0 0 13.864-6.27 20.21-16.104",
    fill: "#f05b26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.06 340.35c0.95 3.361 2.343 6.731 4.396 9.476 0 0 2.644-1.195 6.152-3.362-3.217-3.58-7.353-5.295-10.548-6.114",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.13 345.92s5.908-37.087 33.755-77.29l-16.332-13.615s-28.147 44.353-28.147 79.607z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.06 236.63c-83.59-12.049-88.266 93.301-88.266 93.301 12.344 15.075 32.61 4.7 32.61 4.7s4.214-38.311 44.479-78.347",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.53 277.78s27.274-4.69 37.023-22.757c0 0 25.733 27.615 72.01 38.983 0 0 12.347-49.182-49.65-58.118 0 0-52.482-5.994-59.383 41.892",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.36 327.55s-3.742-64.134 59.487-90.744c0 0-51.309 35.766-51.652 91.872 0 0-2.613 5.249-7.835-1.129",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.54 273.67s-4.755 11.881-3.977 20.561c0 0 5.033-16.825 12.896-23.562",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.87 359.56c-2.63 0.69-5.862 0.553-9.089-0.581-3.182-1.121-5.76-3.005-7.383-5.155-14.864 2.262-21.287 24.934-27.42 42.37-0.323 0.914-0.597 1.807-0.849 2.694 8.654 5.382 8.226 4.637 19.029 8.438 10.087 3.55 20.085 5.94 29.605 7.234 0.411-0.97 0.807-1.971 1.178-3.026 6.15-17.481 4.819-41.064-5.071-51.974",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.34 415.77s11.686-13.212 19.185-12.813l6.606 3.851s-13.65 3.559-16.408 11.844z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.71 403.5s-37.552-30.885 12.006-32.401l5.312 4.351s-41.925 1.698-11.784 23.275c0 0-2 4.423-3.766 4.599",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.92 399.13c-1.96 3.361-0.59 7.813 3.058 9.939s8.195 1.126 10.155-2.236c1.96-3.364 0.591-7.813-3.057-9.94-3.65-2.127-8.196-1.127-10.156 2.237",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.09 369.3s-12.686 21.318-15.241 33.572l-13.268-3.097-0.335-1.097s5.939-29.378 28.844-29.378",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.17 354.05s-24.696 8.249-29.392 11.761c0 0 9.165 13.917 15.516 16.912 0 0 13.702-7.607 18.504-17.632",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.08 366.42s21.101-9.7 26.815-10.694l2.726 2.727-25.495 14.44z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.16 362.55s6.132 9.267 6.132 19.228l1.458-1.701s1.542-6.381-7.59-16.52",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.43 428.99c4.496-4.882 7.345-9.576 6.361-10.481-0.983-0.905-5.425 2.32-9.923 7.202-4.495 4.884-7.345 9.578-6.361 10.483s5.426-2.319 9.923-7.204",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.4 450.37s-5.663 9.611 6.465 21.742c0 0-7.366 0.035-10.366-8.71-3.002-8.744-0.222-13.032 3.901-13.032",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.11 428.24s8.828 14.113 15.79 5.523c6.96-8.592 5.582-14.667 5.582-13.999v0.669l1.859 0.215s-1.074 15.04-12.625 17.706c0 0-4.565 0.266-11.449-8.56z",
    opacity: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.75 139.53c-18.995-2.909-29.988-5.027-29.988-5.027v-31.498l7.967 1.389c5.154 0.876 12.651 2.116 22.021 3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.762 103v-30.427l7.967 1.388c5.154 0.876 12.651 2.116 22.021 3.57v30.428c-9.37-1.454-16.867-2.694-22.021-3.57z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.729 104.39-7.967-1.389c1e-3 0 11.248 2.05 29.988 4.959z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.762 72.578v-26.825s11.248 2.05 29.988 4.959v26.824c-9.37-1.454-16.867-2.694-22.021-3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.729 73.966c5.154 0.876 12.651 2.116 22.021 3.57z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.575 111.16 9.175 1.305v31.478l-14.737-2.063-15.251-2.343v-31.566z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.575 80.727 9.175 1.306v30.427l-9.175-1.305-20.813-3.189v-30.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.575 53.903 9.175 1.305v26.825l-9.175-1.306-20.813-3.189v-26.824z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.926 113.48 12.418 1.661-12.418-1.661-7.164-1.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.75 147.69c-10.76-1.248-20.799-2.521-29.988-3.751v-31.478l29.988 4.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.75 116.49-29.988-4.028v-30.427c9.257 1.315 19.318 2.681 29.988 4.028z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.75 116.49-24.833-3.335z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.762 55.21c9.257 1.316 19.318 2.681 29.988 4.028v26.825c-10.67-1.351-20.73-2.711-29.988-4.028z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.18 118.29 15.571 1.775v30.836c-10.489-1.02-20.514-2.099-29.988-3.204v-31.201z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.762 116.49v-30.428l14.417 1.794 15.571 1.775v30.428l-15.571-1.775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.18 61.034 15.571 1.775v26.824l-15.571-1.775-14.417-1.794v-26.824z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.75 153.52-14.041-1.126-15.947-1.5v-30.836c9.728 1.085 19.761 2.125 29.988 3.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.75 123.13-29.988-3.072v-30.428c9.728 1.085 19.761 2.125 29.988 3.072z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.75 92.706-29.988-3.072v-26.824c9.728 1.085 19.761 2.125 29.988 3.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.76 123.14 18.007 1.603 11.981 0.886v29.971l-22.042-1.434-7.946-0.636z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.76 123.14v-30.428l18.007 1.603 11.981 0.886v30.428l-11.981-0.886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.76 92.707v-26.824l18.007 1.603 11.981 0.886v26.824l-11.981-0.886z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.04 126.38 19.708 1.118v29.464c-10.157-0.359-20.165-0.831-29.988-1.371v-29.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.75 127.5-19.708-1.118-10.28-0.76v-30.428l10.28 0.76 19.708 1.118z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.75 97.075-19.708-1.118-10.28-0.76v-26.824l10.28 0.76 19.708 1.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.75 97.075-17.819-1.01z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.75 157.66-11.212-0.119-18.776-0.572v-29.465c10.053 0.513 20.081 0.882 29.988 1.036z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.75 128.54c-9.899-0.195-19.923-0.555-29.988-1.036v-30.427c10.053 0.512 20.081 0.881 29.988 1.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.76 70.251c10.053 0.513 20.081 0.882 29.988 1.036v26.824c-9.899-0.195-19.923-0.555-29.988-1.035z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.75 157.6-16.524 0.197-13.464-0.143v-29.12l16.905 0.223 13.083-0.163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.76 128.54v-30.428l16.905 0.223 13.083-0.163v30.428l-13.083 0.163z",
    fill: "url(#linearGradient1596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.76 128.54 16.905 0.223 13.083-0.163-13.083 0.163z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.76 98.111v-26.824l16.905 0.223 13.083-0.163v26.824l-13.083 0.163z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m276.76 128.6c9.986-0.102 20.012-0.436 29.988-0.917v29.05l-22.728 0.787-7.26 0.086z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.75 127.68c-9.981 0.438-20.004 0.764-29.988 0.917v-30.428c9.986-0.101 20.012-0.436 29.988-0.917z",
    fill: "url(#linearGradient1590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.75 97.254c-9.981 0.439-20.004 0.765-29.988 0.917v-26.824c9.984-0.153 20.007-0.479 29.988-0.917z",
    fill: "url(#Checker_White)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m336.75 154.92c-9.722 0.723-19.733 1.332-29.988 1.807v-29.05l18.849-1.037 11.139-0.809z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.75 125.84-11.139 0.809-18.849 1.037v-30.427l18.849-1.038 11.139-0.809z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.75 125.84-11.139 0.809-18.849 1.037 18.849-1.037z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.75 68.583v26.824l-11.139 0.809-18.849 1.038v-26.825l18.849-1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.75 123.31v29.057l-15.914 1.492-14.074 1.06v-29.089l15.163-1.174z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.76 125.83v-30.428l15.163-1.174 14.825-1.346v30.428l-14.827 1.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.76 95.406v-26.824c10.201-0.745 20.233-1.605 29.988-2.52v26.824l-14.827 1.324z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.75 149.02c-9.484 1.19-19.504 2.329-29.988 3.352v-29.058l17.751-1.813 12.237-1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.75 120.1-12.237 1.404-17.751 1.813v-30.427l17.751-1.814 12.237-1.404z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.75 120.1-12.237 1.404z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.75 62.843v26.824l-12.237 1.404-17.751 1.814v-26.825l17.751-1.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.76 89.666c7.929-0.924 15.554-1.874 22.799-2.809l-16.976 2.141z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.75 144.9c-9.233 1.398-19.262 2.801-29.988 4.114v-28.923l15.471-1.877c5.005-0.635 9.851-1.276 14.517-1.913z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.75 116.3c-4.664 0.637-9.511 1.276-14.516 1.91l-15.472 1.88v-30.427l15.471-1.878c4.839-0.638 9.678-1.275 14.517-1.912z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.75 85.876c-4.839 0.636-9.678 1.273-14.516 1.909l-15.471 1.881c-1e-3 0-1e-3 -26.825-1e-3 -26.825 10.602-1.234 20.659-2.517 29.988-3.79z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.75 111.92v28.005l-3.436 0.646c-4.471 0.759-8.942 1.518-13.412 2.277l-13.14 2.055v-28.598l8.488-1.159c4.738-0.691 9.475-1.382 14.213-2.073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.76 116.3v-30.428l8.488-1.158c4.738-0.691 9.475-1.383 14.213-2.074l7.287-1.153v30.428l-7.287 1.153c-4.738 0.691-9.475 1.382-14.213 2.073z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.75 81.489-7.287 1.153c-4.738 0.691-9.475 1.383-14.213 2.074l-8.488 1.158v-26.824l8.488-1.159c4.738-0.691 9.475-1.382 14.213-2.073l7.287-1.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.75 134.02-11.952 2.514-18.036 3.39v-28.005l15.939-2.522 14.049-2.426z",
    fill: "url(#Checker_White)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.75 106.97-14.049 2.426-15.939 2.522v-30.428l15.939-2.521 14.049-2.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.75 76.539-14.049 2.427-15.939 2.521v-26.824l15.939-2.522 14.049-2.426z",
    fill: "url(#linearGradient1410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.76 106.96c4.124-0.731 6.35-1.159 6.35-1.159v26.785s-2.197 0.531-6.35 1.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.11 105.81s-2.226 0.428-6.35 1.159v-30.428l6.35-1.158z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.11 75.379-6.35 1.158v-26.825c4.124-0.731 6.35-1.158 6.35-1.158z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.7 473.5c0 4.7029-12.16 8.5148-27.159 8.5148-14.999 0-27.159-3.8119-27.159-8.5148 0-4.7025 12.16-8.5152 27.159-8.5152 15 0 27.159 3.8123 27.159 8.5152",
    fillRule: "nonzero",
    opacity: 0.5,
    strokeWidth: 0.33272
  }), /*#__PURE__*/React.createElement("path", {
    d: "m520.54 473.5c0 4.7029-12.16 8.5148-27.159 8.5148s-27.159-3.8119-27.159-8.5148c0-4.7025 12.16-8.5152 27.159-8.5152 15 0 27.159 3.8123 27.159 8.5152",
    fillRule: "nonzero",
    opacity: 0.5,
    strokeWidth: 0.33272
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.525,
    height: 472.47,
    fill: "#8e6025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.35,
    width: 13.525,
    height: 472.47,
    fill: "#8e6025"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.935,
    width: 4.828,
    height: 472.47,
    fill: "#d7a973"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.25,
    width: 4.828,
    height: 472.47,
    fill: "#d7a973"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningGirlFinishLine);
export default __webpack_public_path__ + "static/media/running-girl-finish-line.9c37f4293488ccaec4ae8f814ff4942b.svg";
export { ForwardRef as ReactComponent };